import _ from 'underscore';
import Backbone from 'backbone';

function randomString() {
  return Math.random().toString(36).slice(2).toUpperCase();
}

function generatePseudoCouponId() {
  return (randomString() + randomString()).slice(0, 20);
}

export var HowPcbangModel = Backbone.Model.extend({
  url: 'how-pcbang',

  defaults: function () {
    return {
      type: '', // KICKOUT_ITEM | POKERCHIP_COUPON | MONEY_COUPON
      couponId: generatePseudoCouponId(),
      couponOption: 'RANDOM', // 'REAL' | 'RANDOM'
      isPchipReceived: null,
      isMoneyReceived: null,
      isKicoutItemReceived: null,
      resultCode: '',
      resultText: '',
      isSuccess: null,
      reward: null
    };
  },

  initialize: function () {},

  setRealCoupon: function () {
    this.set('couponOption', 'REAL');
  },

  setType: function (type) {
    switch (type) {
      case 'kickout':
        this.set('type', 'KICKOUT_ITEM');
        break;
      case 'pchip':
        this.set('type', 'POKERCHIP_COUPON');
        break;
      case 'money':
        this.set('type', 'MONEY_COUPON');
        break;
      default:
        this.set('type', '');
    }
  },

  parse: function (res) {
    return _.extend(this.toJSON(), res.result, { type: '' });
  }
});
